import { isValidPhoneNumber } from "react-phone-number-input";
import * as Yup from "yup";

export const SignInSchema = Yup.object().shape({
  email: Yup.string().email("Please enter a valid email").required("Email is required"),
  password: Yup.string()
    .min(6, "Password should be at least 6 characters")
    .required("Password is required"),
});

export const ForgotPasswordSchema = Yup.object().shape({
  email: Yup.string().email("Invalid email").required("Email is required"),
});

export const ResetPasswordSchema = Yup.object().shape({
  password: Yup.string().min(8, "Minimum 8 characters").required("Password is required"),
  confirmPassword: Yup.string()
    .oneOf([Yup.ref("password"), null], "Passwords must match")
    .required("Confirm your password"),
});

export const AddClientSchema = Yup.object().shape({
  name: Yup.string().required("Client name is required"),
  email: Yup.string().email("Invalid email").required("Email is required"),
  contactNumber: Yup.string()
    .required("Contact number is required")
    .test("is-valid-phone", "Invalid phone number", (value) => value && isValidPhoneNumber(value)),
  hotels: Yup.array()
    .of(
      Yup.object().shape({
        name: Yup.string()
          .required("Hotel name is required")
          .min(5, "Hotel name must be at least 5 characters long"),
        address: Yup.string()
          .min(5, "Address must be at least 5 characters long")
          .required("Hotel address is required"),
        timezone: Yup.string().required("Timezone is required"),
      })
    )
    .min(1, "At least one hotel is required"),
});

export const CreateRoleSchema = Yup.object().shape({
  title: Yup.string().trim().required("Role title is required"),
  permissions: Yup.object().test(
    "at-least-one-view",
    "At least one screen view permission is required",
    (permissions = {}) =>
      Object.keys(permissions).some((key) => key.startsWith("view") && permissions[key] === true)
  ),
});

export const AddUserSchema = Yup.object().shape({
  name: Yup.string().required("Name is required"),
  email: Yup.string().email("Invalid email address").required("Email is required"),
  roleId: Yup.string().required("Please assign a role"),
  contactNumber: Yup.string()
    .required("Contact number is required")
    .test("is-valid-phone", "Invalid phone number", (value) => value && isValidPhoneNumber(value)),
});

export const profileSchema = Yup.object().shape({
  fullName: Yup.string().required("Full name is required"),
  contactNumber: Yup.string()
    .required("Contact number is required")
    .test("valid-phone", "Invalid phone number", (value) => {
      if (!value) return false;
      return isValidPhoneNumber(value);
    }),
});

export const passwordSchema = Yup.object({
  currentPassword: Yup.string().required("Current password is required"),

  newPassword: Yup.string()
    .required("New password is required")
    .min(8, "Password must be at least 8 characters"),

  confirmPassword: Yup.string()
    .oneOf([Yup.ref("newPassword")], "Passwords do not match")
    .required("Confirm password is required"),
});

export const IntegrationSchema = Yup.object({
  key: Yup.string()
    .trim()
    .required("Provider key is required")
    .matches(/^[a-z0-9-_]+$/, "Only lowercase letters, numbers, - and _ allowed"),

  displayName: Yup.string().trim().required("Display name is required"),

  description: Yup.string().max(300),

  logoUrl: Yup.string().url("Invalid URL").nullable(),

  learnMore: Yup.string().url("Must be a valid URL").notRequired(),

  supportsWebhooks: Yup.boolean(),
  supportsPolling: Yup.boolean(),
  supportsPropertyDiscovery: Yup.boolean(),

  credentialFields: Yup.array().of(
    Yup.object({
      name: Yup.string().required("Required"),
      label: Yup.string().required("Required"),
      type: Yup.string()
        .oneOf(["string", "password", "number", "boolean", "json"])
        .required("Required"),
      required: Yup.boolean(),
      secret: Yup.boolean(),
      placeholder: Yup.string().nullable(),
      helpText: Yup.string().nullable(),
      options: Yup.array().of(Yup.string()),
    })
  ),
});
